import "./App.css";
import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import Home from "./Pages/Home";
import Login from "./Pages/Login";
import Register from "./Pages/Register";
import Footer from "./components/Shared/Footer/Footer";
import RequireAuth from "./components/Shared/RequireAuth";
import Package from "./components/HomePage/Package";
import PaymentPending from "./Pages/Buyer/PaymentPending";
import { Toaster } from "react-hot-toast";
import PayNow from "./Pages/Buyer/PayNow";
import ResetPassword from "./Pages/ResetPassword";
import Contact from "./components/HomePage/Contact";
import About from "./Pages/About";
import ErrorPage from "./Pages/ErrorPage";
import SupportMessages from "./Pages/Admin/SupportMessages/SupportMessages";
import BuyerSupport from "./Pages/Seller/SupportMessage/BuyerSupport";
import DashboardLayout from "./components/AiHomePage/Dashboard/DashboardLayout";
import DashboardHome from "./components/AiHomePage/Dashboard/DashboardHome";
import OrdersList from "./components/AiHomePage/Dashboard/OrdersList";
import Packages from "./components/Admin/Packages";
import AdminDashboardLayout from "./components/AiHomePage/Dashboard/AdminDashBoard/AdminDashboardLayout";
import AdminDashboardHome from "./components/AiHomePage/Dashboard/AdminDashBoard/AdminDashboardHome";
import ManageUsers from "./components/AiHomePage/Dashboard/AdminDashBoard/ManageUsers";
import SettingsHome from "./components/Admin/Settings/SettingsHome";
import SubscriptionHistory from "./components/AiHomePage/Dashboard/SubscriptionHistory";
import AdminAuth from "./Pages/Seller/AdminAuth";
import SelectPackage from "./components/AiHomePage/SelectPackage";
import ItemsPakage from "./components/HomePage/ItemsPakage";
import ItemPayNow from "./Pages/Buyer/ItemPayNow";
import ItemsOrders from "./Pages/Admin/ItemsOrders";
import ItemsPaymentPending from "./Pages/Buyer/ItemsPaymentPending";
import PackagePaymentPending from "./Pages/Buyer/PackagePaymentPending";
import UserProfileUpdate from "./components/Admin/Settings/AccountSettings";
import BuyerCreateSupportTicket from "./Pages/Seller/SupportMessage/BuyerCreateSupportTicket";
import NavBar from "./components/YouTubeThumbnailHome/NavBar";
import ProductDescriptionGenerator from "./components/YouTubeThumbnailHome/ProductDescriptionGenerator";
import ThankYouPage from "./Pages/Buyer/ThankYouPage";

function App() {
  const location = useLocation();

  // Define paths where you don't want the NavBar and Footer
  const hideNavAndFooter =
    location.pathname.startsWith("/user") ||
    location.pathname.startsWith("/admin") ||
    location.pathname.startsWith("/admin");
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location]);

  return (
    <div>
      <Toaster />
      {!hideNavAndFooter && <NavBar />}

      <Routes>
        <Route path="*" element={<ErrorPage />}></Route>
        <Route path="/login" element={<Login />}></Route>
        <Route path="/register" element={<Register />}></Route>
        <Route path="/reset-password" element={<ResetPassword />}></Route>
        <Route path="/about" element={<About />}></Route>
        <Route path="/contact" element={<Contact />}></Route>
        <Route path="/buy/:id"element={ <RequireAuth><Package /></RequireAuth>}></Route>
        <Route path="/item-buy/:id" element={ <RequireAuth><ItemsPakage/></RequireAuth>}></Route>
        <Route path="/pay-now/:id" element={<RequireAuth><PayNow /></RequireAuth>}></Route>
        <Route path="/item-pay-now/:id"element={<RequireAuth><ItemPayNow /></RequireAuth>}></Route>

        {/* Protected user routes */}
        <Route path="/user" element={<RequireAuth><DashboardLayout /></RequireAuth>} >
          <Route path="dashboard" element={<DashboardHome />} />
          <Route path="orders" element={<OrdersList />} />
          <Route path="select-package" element={<SelectPackage />} />
          <Route path="create-support" element={<BuyerCreateSupportTicket />} />
          <Route path="support" element={<BuyerSupport />} />
          
          <Route path="pending-payment" element={<PaymentPending />} />
          <Route path="item-pending-payment" element={<ItemsPaymentPending />} />
          <Route path="package-pending-payment" element={<PackagePaymentPending />} />
          <Route path="subscription-history" element={<SubscriptionHistory />} />
          <Route path="thank-you/:id" element={<ThankYouPage />} />
          <Route path="generate-product-description" element={<ProductDescriptionGenerator />} />
        </Route>

        {/* Protected admin routes */}
        <Route path="/admin" element={<RequireAuth><AdminAuth><AdminDashboardLayout /></AdminAuth></RequireAuth>}>
          <Route path="dashboard" element={<AdminDashboardHome />} />
          <Route path="orders" element={<OrdersList />} />
          <Route path="items-orders" element={<ItemsOrders />} />
          <Route path="admins" element={<ManageUsers />} />
          <Route path="support-messages" element={<SupportMessages />} />
          <Route path="settings" element={<SettingsHome />} />
          <Route path="packages" element={<Packages />} />
        </Route>

        <Route path="/" element={<Home />}></Route>
        <Route path="/update-profile" element={<UserProfileUpdate />}></Route>
      </Routes>
      {!hideNavAndFooter && <Footer />}
    </div>
  );
}

export default App;
